import type { DomainDnsRecords } from '@fourthwall/services/dist/DnsApiClient/models'

import type { PartialEntriConfig } from '../providers/Entri'

const mapDomainDnsRecordsToEntriDnsRecords = (
  dnsList: DomainDnsRecords,
): PartialEntriConfig['dnsRecords'] =>
  dnsList.list.map(({ host = '', value = '', priority = 10, recordType, zoneFile }) => ({
    host: zoneFile?.hostLabel || host,
    value,
    type: recordType,
    ttl: 300,
    priority,
  }))

export const getEntriConfig = (dnsList: DomainDnsRecords, shopId: string): PartialEntriConfig => ({
  userId: shopId,
  dnsRecords: mapDomainDnsRecordsToEntriDnsRecords(dnsList),
  prefilledDomain: dnsList.domain,
})
